export default __webpack_public_path__ + "static/media/arrow-angle-right-red.173a23fa.svg";